export function getItemSelections(orderItem) {
    const addOns = [];
    const items = [];
    const meal = orderItem.get('meal_value');
    const note = orderItem.get('note');
    orderItem.instances.forEach((instance) => {
        if (instance.get('itemTemplate').get('type') === 'addon') {
            instance.itemOptions.forEach((option) => {
                const optionId = option.get('option').id;
                const itemTemplateId = option.get('itemInstance').get('itemTemplate').id;
                const instanceId = option.get('itemInstance').id;
                addOns.push({
                    membershipId: instance.addOns[0].id,
                    option: { objectId: optionId },
                    optionName: option.get('optionName'),
                    optionValue: option.get('optionValue'),
                    children: option.get('children'),
                    itemInstance: { objectId: instanceId },
                    itemTemplateId: itemTemplateId
                });
            });
        }
        else {
            instance.itemOptions.forEach((optionInstance) => {
                const optionId = optionInstance.get('option').id;
                const instanceId = optionInstance.get('itemInstance').id;
                const itemTemplateId = optionInstance.get('itemInstance').get('itemTemplate').id;
                items.push({
                    option: { objectId: optionId },
                    optionName: optionInstance.get('optionName'),
                    optionValue: optionInstance.get('optionValue'),
                    children: optionInstance.get('children'),
                    itemInstance: { objectId: instanceId },
                    itemTemplateId: itemTemplateId,
                });
            });
        }
    });
    return { items, addOns, meal, note };
}
export function updateOrderItemSelectedValues(itemOptionSelections, itemOption) {
    itemOptionSelections = itemOptionSelections.filter(item => {
        return item.id !== itemOption.id;
    });
    itemOptionSelections.push(itemOption);
    return itemOptionSelections;
}
export function updateOrderItemAddOnSelections(itemOptionSelections, itemOption) {
    itemOptionSelections = itemOptionSelections.filter(item => {
        return item.id !== itemOption.id;
    });
    itemOptionSelections.push(itemOption);
    return itemOptionSelections;
}
